export default [
    {
        path: '/procurement/purchase',
        name: 'purchase',
        props: true,
        component: () => import('@/views/procurement/purchase/index.vue'),
        meta: {
            pageTitle: 'Purchase',
            breadcrumb: [
                {
                text: 'Purchase',
                active: true,
                },
            ],
        },
    },
    {
        path: '/procurement/purchase/add',
        name: 'create-purchase',
        component: () => import('@/views/procurement/purchase/create.vue'),
        meta: {
            pageTitle: 'Create Purchase',
            breadcrumb: [
                {
                text: 'Purchase',
                to: { name: 'purchase' },
                },
                {
                text: 'Create Purchase',
                active: true,
                },
            ],
        },
    },
    {
        path: '/procurement/purchase/:id',
        name: 'detail-purchase',
        props: true,
        component: () => import('@/views/procurement/purchase/detail.vue'),
        meta: {
            pageTitle: 'Detail Purchase',
            breadcrumb: [
                {
                text: 'Purchase',
                to: { name: 'purchase' },
                },
                {
                text: 'Detail Purchase',
                active: true,
                },
            ],
        },
    },
    {
        path: '/procurement/purchase/:id/invoice',
        name: 'invoice-purchase',
        props: true,
        component: () => import('@/views/procurement/purchase/invoice.vue'),
        meta: {
            pageTitle: 'Invoice Purchase',
            breadcrumb: [
                {
                text: 'Purchase',
                to: { name: 'purchase' },
                },
                {
                text: 'Invoice Purchase',
                active: true,
                },
            ],
        },
    },
]